import { TFunction } from "i18next";
import DefaultIzProvider from "./DefaultIzProvider";

export class DistrictOfColumbia extends DefaultIzProvider {
  constructor(izDestinationId: string, t: TFunction) {
    super(izDestinationId, t);
    this.reportTitles = [t("immunizations.records_history_report_dc")];
    this.statusImages.useNoRecordImage = true;
    this.scenarioBImagePath = "/assets/images/large/Docket_DC_scb_f.png";
  }

  fillOutI18nDefinitions(): never {
    throw new Error("Method not implemented.");
  }
}
